var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHdfcBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_577_20732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000183105H18V17.9998H0V-0.000183105Z",
    fill: "#ED232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15234 3.1545H14.8536V14.8558H3.15234V3.1545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 -0.000183105H9.89889V17.9998H8.09961V-0.000183105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.09488H18V9.89417H0V8.09488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 6.2978H11.701V11.6981H6.30078V6.2978Z",
    fill: "#004C8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000183105H18V17.9998H0V-0.000183105Z",
    fill: "#ED232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15234 3.1545H14.8536V14.8558H3.15234V3.1545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 -0.000183105H9.89889V17.9998H8.09961V-0.000183105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.09488H18V9.89417H0V8.09488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.30078 6.2978H11.701V11.6981H6.30078V6.2978Z",
    fill: "#004C8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_20732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdfcBank);
export default __webpack_public_path__ + "static/media/hdfc-bank.a4f23442db6f592adda6a9ec534fe00c.svg";
export { ForwardRef as ReactComponent };